// extracted by mini-css-extract-plugin
export default {"StorageConditions":"StorageConditions_StorageConditions__Xw61B","StorageConditionsWrapper":"StorageConditions_StorageConditionsWrapper__48OW-"};